import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { swalMessages } from 'src/constants';
import Grid from '@material-ui/core/Grid';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import Card from 'src/components/sharedComponents/Card/Card';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput';
import MaterialTable  from '@material-table/core'
import fontsService from 'src/services/fontsService';
import reportRequestService from 'src/services/reportRequestService';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import convertDate from 'src/utils/formatDate';
import Typography from '@material-ui/core/Typography';
import { SelectInput } from 'src/pages/AdminControl/styles';
import { MenuItem } from '@material-ui/core';
import { loaderService } from 'src/services/loaderService';

const initialState = {
  fuentes: [],
  descripcion: ' ',
};

const ReportRequest = () => {
  const [listRequest, setListRequest] = useState([]);
  const [create, setCreate] = useState(initialState);
  const [selected, setSelected] = useState([]);
  const [fonts, setFonts] = useState('');
  const date = new Date();

  // obtener listado de solicitudes
  const getReportDataStudio = async () => {
    const response = await reportRequestService.getRequestReport();
    if (response) {
      setListRequest(response.data);
      console.log(response);  
    } else {
      swal(swalMessages.WARNING_DATASTUDIO);
    }
    setCreate(initialState);
  };

  // obtener listado de fuentes DataStudio para el select
  const getFuentesDataStudio = async () => {
    const response = await fontsService.getFontsDataStudio();
    if (response) {
      setFonts(response);
    } else {
      swal(swalMessages.WARNING_GENERAL);
    }
    setCreate(initialState);
  };

  // Enviar solicitud de reporte
  const handleSubmit = async (event) => {
    loaderService.show();
    event.preventDefault();
    if (create.fuentes.length === 0) {
      return swal(swalMessages.WARNING_GENERAL);
    }
    const response = await reportRequestService.postRequestReport(create);
    if (response.success === 0) {
      swal(swalMessages.WARNING_GENERAL);
    } else {
      swal(swalMessages.SUCCESSFUL_MESSAGE);
      getReportDataStudio();
    }
    setCreate(initialState);
    setSelected([]);
    loaderService.hide();
  };

  useEffect(() => {
    getReportDataStudio();
    getFuentesDataStudio();
  }, []);

  const getValueFontsSelect = (e) => {
    const data = e.map((f) => f.id).filter((x) => x !== e.id);
    setCreate({
      ...create,
      fuentes: data,
    });
    const result = e.reduce((acc, item) => {
      if (!acc.includes(item.id)) {
        acc.push(item);
      }
      return acc;
    }, []);
    setSelected(result);
  };

  const onChangeInput = (event, type) => {
    event.preventDefault();
    setCreate((prev) => ({
      ...prev,
      [type]: event.target.value,
    }));
  };

  return (
    <>
      <CardTitle
        title="Solicitud creación de reportes"
        subTitle="Solicitud administrativa "
      />
      <Grid container justifyContent="center" spacing={2}>
        <Card>
          <CardHeader color="customAuteco" stats icon>
            <CardIcon color="customAuteco">
              <PresentToAllIcon />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <form justify="center" autoComplete="off" onSubmit={handleSubmit}>
              <Grid container>
                <Typography>
                  En esta sección solicita permisos para crear reportes, no
                  olvides seleccionar las fuentes necesarias para ello.
                </Typography>
                <Grid item xs={12} md={12} sm={12}>
                  <CustomInput
                    labelText="Nombre del reporte"
                    id="Nombre"
                    formControlProps={{
                      fullWidth: true,
                      required: true,
                    }}
                    inputProps={{
                      value: create.nombre || '',
                      onChange: (event) => onChangeInput(event, 'nombre'),
                      type: 'text',
                      autoComplete: 'off',
                    }}
                  />
                  <CustomInput
                    labelText="Descripción"
                    id="Descripción"
                    formControlProps={{
                      fullWidth: true,
                      required: false,
                    }}
                    inputProps={{
                      value: create.descripcion || '',
                      onChange: (event) => onChangeInput(event, 'descripcion'),
                      type: 'text',
                      autoComplete: 'off',
                    }}
                  />
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <SelectInput
                        fullWidth
                        required
                        label="Tipo"
                        variant="standard"
                        select
                        onChange={(event) => onChangeInput(event, 'tipoReporte')}
                      >
                        <MenuItem value="MOTOS A COMBUSTION">
                          MOTOS A COMBUSTION
                        </MenuItem>
                        <MenuItem value="PRESIDENCIA">PRESIDENCIA</MenuItem>
                        <MenuItem value="MICE">MICE</MenuItem>
                        <MenuItem value="REPUESTOS">REPUESTOS</MenuItem>
                        <MenuItem value="CARPA">CARPA</MenuItem>
                      </SelectInput>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        multiple
                        value={selected}
                        id="tags-standard"
                        options={
                          fonts.length > 0
                            ? fonts?.map((f) => ({
                              value: f.nombre,
                              label: f.nombre,
                              id: f.id,
                            }))
                            : []
                        }
                        filterSelectedOptions
                        freeSolo
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Selección de fuentes"
                          />
                        )}
                        onChange={(event, newValue) => {
                          getValueFontsSelect(newValue);
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    type="onSubmit"
                    color="warning"
                    disabled={create?.fuentes?.length === 0}
                  >
                    Enviar Solicitud
                  </Button>
                </Grid>
              </Grid>
            </form>
          </CardBody>
        </Card>
        <Grid item xs={12} md={12} sm={12}>
          <MaterialTable
            title="Solicitudes"
            columns={[
              { title: 'Fecha', field: 'Fecha' },
              { title: 'Reporte', field: 'Reporte' },
              { title: 'Descripción', field: 'Descripción' },
              { title: 'Estado', field: 'Estado' },
              { title: 'Fuentes', field: 'Fuentes' },
              { title: 'Tipo', field: 'Tipo' },
            ]}
            data={listRequest?.map((item) => ({
              Fecha: convertDate(date),
              Reporte: item.nombre,
              Descripción: item.descripcion,
              Estado: item.estado,
              Tipo: item.tipo_reporte,
              Fuentes: item.fuentes?.map((fuente) => fuente.nombre),
            }))}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ReportRequest;
